import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import Reveal from "@/components/Reveal";
import api from "@/lib/api";

export const LatestJournal = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog")
      .then((r) => {
        const sorted = [...(r.data || [])].sort((a, b) => String(b.publishedAt || "").localeCompare(String(a.publishedAt || "")));
        setPosts(sorted.slice(0, 3));
      })
      .catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="border-b border-border bg-white py-24" data-testid="home-journal">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="overline mb-4">From the Journal</div>
            <h2 className="max-w-2xl font-serif text-4xl text-ink sm:text-5xl">Fresh reading on <span className="italic text-clay">healing.</span></h2>
          </div>
          <Link to="/blog" data-testid="home-journal-all" className="inline-flex items-center gap-2 font-sans text-sm text-ink underline-offset-4 hover:underline">
            Read all articles <ArrowRight size={14} />
          </Link>
        </div>
        <div className="mt-14 grid gap-px overflow-hidden border border-border bg-border md:grid-cols-3">
          {posts.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.08}>
              <Link to={`/blog/${p.slug}`} data-testid={`home-journal-card-${p.slug}`} className="group flex h-full flex-col bg-white transition-colors hover:bg-linen">
                <div className="aspect-[3/2] overflow-hidden">
                  <img src={p.coverImage} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                </div>
                <div className="flex flex-1 flex-col p-8">
                  <div className="overline mb-3 flex items-center gap-2"><Clock size={12} />{p.readMinutes} min · {p.tags?.[0]}</div>
                  <h3 className="font-serif text-2xl leading-tight text-ink">{p.title}</h3>
                  <p className="mt-3 font-sans text-sm leading-relaxed text-ink-soft">{p.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 font-sans text-xs text-clay transition-transform group-hover:translate-x-1">Read <ArrowRight size={13} /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
